import React, {useState} from 'react';
import { useHistory, Link } from "react-router-dom";
import {login} from '../service/UserService';
import ClipLoader from "react-spinners/ClipLoader";
import { Eye, EyeOff } from 'lucide-react';

function Login(props) {
    const history = useHistory();
    const [email, setEmail] = useState(process.env.NODE_ENV === 'development'? "keichiro13@gmail.com":"");
    const [password, setPassword] = useState("");
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    
    const handleSubmitClick = (e) => {
        e.preventDefault();
        setLoading(true);

        login(email, password).then((responseJson) => {
            //console.log("resp:", responseJson);
            setLoading(false);
            if(!responseJson ){
                setError("Hiba történt, kérem próbálja újra később");
                return;
            }
            if(responseJson && responseJson.status === true){
                //console.log("Succsessful login");
                
                props.clickLogin();
                if(responseJson.isAdmin === '1'){
                    history.push("/admin");
                }
                else{
                    history.push("/fooldal");
                }
            }
            else{
                setError("Hibás felhasználónév vagy jelszó!");
            }
        });
    }

    const handleKeyDown= (e) => {
        if (e.key === 'Enter') {
            handleSubmitClick(e);
        }
    }

    const togglePasswordVisibility = () => {
        setIsPasswordVisible((prevState) => !prevState);
    };

    return(
        <div>
            {!isLoading && 
            <div id="kwizda-login-form" className="kwizda-form card"
            style={{margin: 'auto', marginBottom: 20}}>
                <h2 className="kwizda-page-title">Bejelentkezés</h2>
                <label>E-mail</label>
                <input type="text" value={email} placeholder="E-mail"
                onChange={(e) => setEmail(e.target.value)}></input>
                <label>Jelszó</label>
                <div className="password-input-container">
                    <input className="kwizda-form"
                        type={isPasswordVisible ? 'text' : 'password'} value={password} placeholder="Jelszó"
                        onChange={(e) => setPassword(e.target.value)} onKeyDown={handleKeyDown} />
                    <span className="toggle-visibility" onClick={togglePasswordVisibility}>
                        {isPasswordVisible ? <EyeOff size={18} /> : <Eye size={18} />}
                    </span>
                </div>
                <button id="kwizda-login-button"
                        className="kwizda-button"
                        type="submit" 
                        onClick={handleSubmitClick}
                >
                        Bejelentkezés
                </button>
                <span style={{color: "red"}}>{error}</span>
                <div style={{marginTop:20, textAlign:'center'}}>Még nem regisztrált? <Link className="kwizda3-link" to="/regisztracio">Regisztráljon itt.</Link> </div>
                <div style={{marginTop:20, textAlign:'center'}}>Elfelejtette a <Link className="kwizda3-link" to="/emlekezteto">jelszavát ?</Link></div>
            </div>
            }
            <ClipLoader loading={isLoading} size={80} />
        </div>
  )
}

export default Login;